import { Component, OnInit, AfterViewInit } from "@angular/core";
@Component({
  selector: "modal-imposto-de-renda",
  templateUrl: "./modal-imposto-de-renda.component.html",
  styleUrls: ["./modal-imposto-de-renda.component.scss"],
})
export class ModalImpostoDeRendaComponent implements OnInit {
  showModal: any;
  constructor() {}

  ngOnInit(): void {}

  redirectPage(): void {
    window.open(
      "https://geia.facilinformatica.com.br/Administracao/Login.aspx"
    );
  }
}
